(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("stepper", [], factory);
	else if(typeof exports === 'object')
		exports["stepper"] = factory();
	else
		root["stepper"] = factory();
})(this, function() {
return 